import React from 'react';

export default function WigetBox({
  children,
  extraClassName,
}: {
  children: React.ReactNode;
  extraClassName?: string;
}) {
  return (
    <div
      className={`
                  md:border-[1px] 
                  md:border-secondary-50 
                  md:border-solid
                  p-[20px] 
                  w-full
                  md:w-[600px] 
                  md:mx-auto
                  rounded-lg ${extraClassName || ''}`}
    >
      {children}
    </div>
  );
}
